<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="应用端">
                <a-select v-model="queryParam.appIdent" allow-clear placeholder="请选择应用端">
                  <a-select-option value="guzhu">雇主端</a-select-option>
                  <a-select-option value="shifu">师傅端</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="平台">
                <a-select v-model="queryParam.appType" allow-clear placeholder="请选择平台">
                  <a-select-option :value="0">安卓</a-select-option>
                  <a-select-option :value="1">iOS</a-select-option>
                  <a-select-option :value="2">通用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="版本号">
                <a-input v-model="queryParam.versionCode" allow-clear placeholder="请输入版本号"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="更新类型">
                  <a-select v-model="queryParam.upType" allow-clear placeholder="请选择更新类型">
                    <a-select-option :value="0">热更新</a-select-option>
                    <a-select-option :value="1">整包更新</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="升级策略">
                  <a-select v-model="queryParam.compulsoryUp" allow-clear placeholder="请选择升级策略">
                    <a-select-option :value="0">强制升级</a-select-option>
                    <a-select-option :value="1">可跳过</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="发布时间">
                  <a-range-picker
                    v-model="queryParam.dateRange"
                    allow-clear
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span :style="advanced && { float: 'right', overflow: 'hidden' } || {}" class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <a style="margin-left: 8px" @click="toggleAdvanced">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button v-hasPermi="['biz:app/version:add']" type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus"/>新增
        </a-button>
        <a-button v-hasPermi="['biz:app/version:edit']" :disabled="single" type="primary" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit"/>修改
        </a-button>
        <a-button v-hasPermi="['biz:app/version:remove']" :disabled="multiple" type="danger" @click="handleDelete">
          <a-icon type="delete"/>删除
        </a-button>
        <a-button v-hasPermi="['biz:app/version:export']" type="primary" @click="handleExport">
          <a-icon type="download"/>导出
        </a-button>
        <a-button v-hasPermi="['biz:app/version:list']" @click="handleShowDownloadQr">
          <a-icon type="qrcode"/>下载二维码
        </a-button>
        <table-setting
          v-model="columns"
          :refresh-loading="loading"
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          @refresh="getList"
        />
      </div>

      <create-form ref="createForm" @ok="getList"/>
      <download-qr-modal ref="downloadQrModal"/>

      <a-table
        :bordered="tableBordered"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1800 }"
        :size="tableSize"
        rowKey="id"
      >
        <span slot="appIdent" slot-scope="text, record">
          <a-tag v-if="record.appIdent === 'guzhu'" color="blue">雇主端</a-tag>
          <a-tag v-else-if="record.appIdent === 'shifu'" color="green">师傅端</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="appType" slot-scope="text, record">
          <a-tag v-if="record.appType == 0" color="cyan">安卓</a-tag>
          <a-tag v-else-if="record.appType == 1" color="purple">iOS</a-tag>
          <a-tag v-else-if="record.appType == 2" color="orange">通用</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="upType" slot-scope="text, record">
          <a-tag v-if="record.upType == 0" color="blue">热更新</a-tag>
          <a-tag v-else-if="record.upType == 1" color="geekblue">整包更新</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="compulsoryUp" slot-scope="text, record">
          <a-tag v-if="record.compulsoryUp == 0" color="red">强制升级</a-tag>
          <a-tag v-else-if="record.compulsoryUp == 1" color="green">可跳过</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="planUpType" slot-scope="text, record">
          <a-tag v-if="record.planUpType == 0" color="green">立即生效</a-tag>
          <a-tag v-else-if="record.planUpType == 1" color="orange">计划生效</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="upUrlType" slot-scope="text, record">
          <a-tag v-if="record.upUrlType == 0" color="blue">内部地址</a-tag>
          <a-tag v-else-if="record.upUrlType == 1" color="gold">应用市场</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="planUpTime" slot-scope="text, record">
          {{ formatTimestamp(record.planUpTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="operation" slot-scope="text, record">
          <a v-hasPermi="['biz:app/version:edit']" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>修改
          </a>
          <a-divider v-hasPermi="['biz:app/version:remove']" type="vertical"/>
          <a v-hasPermi="['biz:app/version:remove']" @click="handleDelete(record)">
            <a-icon type="delete"/>删除
          </a>
        </template>
      </a-table>

      <a-pagination
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        :total="total"
        class="ant-table-pagination"
        show-quick-jumper
        show-size-changer
        @change="changeSize"
        @showSizeChange="onShowSizeChange"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delAppVersion, pageAppVersion } from '@/api/app/appVersion'
import CreateForm from './modules/CreateForm'
import DownloadQrModal from './modules/DownloadQrModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'AppVersion',
  components: {
    CreateForm,
    DownloadQrModal
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: this.buildQueryParam(),
      columns: [
        {
          title: '应用端',
          dataIndex: 'appIdent',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'appIdent' }
        },
        {
          title: '平台',
          dataIndex: 'appType',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'appType' }
        },
        {
          title: '版本名称',
          dataIndex: 'versionName',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '版本号',
          dataIndex: 'versionCode',
          width: 100,
          align: 'center'
        },
        {
          title: '更新类型',
          dataIndex: 'upType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'upType' }
        },
        {
          title: '升级策略',
          dataIndex: 'compulsoryUp',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'compulsoryUp' }
        },
        {
          title: '地址类型',
          dataIndex: 'upUrlType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'upUrlType' }
        },
        {
          title: '应用市场地址',
          dataIndex: 'upUrl',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '下载地址',
          dataIndex: 'downloadUrl',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '生效方式',
          dataIndex: 'planUpType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'planUpType' }
        },
        {
          title: '生效时间',
          dataIndex: 'planUpTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'planUpTime' }
        },
        {
          title: '更新说明',
          dataIndex: 'upNotes',
          width: 220,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 140,
          fixed: 'right',
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    buildQueryParam() {
      return {
        appIdent: undefined,
        appType: undefined,
        versionCode: undefined,
        upType: undefined,
        compulsoryUp: undefined,
        dateRange: [],
        pageNum: 1,
        pageSize: 10
      }
    },
    buildSearchParams() {
      const params = {
        ...this.queryParam
      }
      delete params.dateRange
      if (this.queryParam.dateRange && this.queryParam.dateRange.length === 2) {
        params.createBeginTime = this.queryParam.dateRange[0] + ' 00:00:00'
        params.createEndTime = this.queryParam.dateRange[1] + ' 23:59:59'
      }
      return params
    },
    getList() {
      this.loading = true
      pageAppVersion(this.buildSearchParams()).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = this.buildQueryParam()
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(row) {
      const that = this
      const ids = row && row.id ? [row.id] : this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids.join(',') + '的数据',
        onOk() {
          return delAppVersion(ids.map(id => ({ id }))).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        }
      })
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('/biz/app-version/export', that.buildSearchParams(), `APP版本管理_${new Date().getTime()}.xlsx`)
        }
      })
    },
    handleShowDownloadQr() {
      this.$refs.downloadQrModal.open()
    },
    formatTimestamp(timestamp) {
      if (!timestamp) {
        return '-'
      }
      return this.parseTime(new Date(Number(timestamp)))
    }
  }
}
</script>
